<template>
  <!-- 20230704 삭제 
  <div class="main-content-header">
    <h2>{{ $t("title.pattern") }}</h2>
  </div>
  -->
  <div class="main-content-body">
    <div class="sub-content">
      <div class="pattern-contents">
        <!-- 20230704 추가 { -->
        <div class="main-content-title">
          <h2>{{ $t("title.pattern_ATC") }}</h2>
        </div>
        <!-- } 20230704 추가 -->
        <AsideContentList 
          :parentMenuCode="parentMenuCode"
          :patternContents="patternContents"
          @selectTab="selectTab"
          />
        <!-- 20230612 버튼 변경 { -->
        <div class="pattern-content-buttons">
          <button class="btn" @click="refreshTab()">
            <span class="material-symbols-outlined">restart_alt</span>
          </button>
          <div class="btn-dropdown-group">
            <button @click="onPatternReport('report')">
              {{ $t("button.reporting") }}
            </button>
            <!-- 20230525 버튼 아이콘 변경 { -->
            <div v-if="!customer.impossibleExcel" class="btn-dropdown" @focusout="focusout">
              <button @click="dropIt">
                <span class="material-symbols-outlined">
                  {{ isDropped ? "expand_less" : "expand_more" }}
                </span>
              </button>
              <div
                class="btn-dropdown-content"
                v-if="isDropped"
                @mouseover="handleMouseOver"
                @mouseout="handleMouseOut"
              >
                <a href="#" @click="onStartDossierExcel()">
                  {{ $t("button.excel_export")}}
                </a>
                <a href="#" @click="onStartDossierEmail()">
                  {{ $t("button.email_export") }}
                </a>
                <!-- <a href="#">{{ $t("button.mdx_view") }}</a> -->
              </div>
            </div>
            <!-- } 20230525 버튼 아이콘 변경 -->
          </div>
        </div>
      </div>
      <!-- } 20230612 버튼 변경 -->

      <div class="content">
        <component
          v-if="isLoad && contents && contents.length > 0 && isComponent"
          :is="selectedComponent"
          v-bind:selectedComponentIndex="selectedComponentIndex"
          v-bind:parentMenu="parentMenu"
          v-bind:parentMenuCode="parentMenuCode"
          :customFunction="selectTab"
        />
        <PatternReport
          v-if="isAnalysisComplete"
          v-bind:parentMenuCode="parentMenuCode"
          v-bind:viewType="viewType"
        />
        <!-- 20230704 다음 스텝 버튼 변경 { -->
        <div class="next-step-wrap">
          <button
            v-if="patternContentIndex !== 0 && !isAnalysisComplete"
            class="btn prev-button"
            @click="goToBeforeTab"
            :style="{ '--button-text': JSON.stringify($t('button.prev_step')) }"
          ></button>
          <button
            v-if="patternContentIndex !== contents.length - 1 && !isAnalysisComplete"
            class="btn next-button"
            @click="goToNextTab"
            :style="{ '--button-text': JSON.stringify($t('button.next_step')) }"
          ></button>
        </div>
        <!-- } 20230704 다음 스텝 버튼 변경 -->
      </div>
    </div>
  </div>
  <AlertDialog
    v-if="isAlertDialogOpen"
    :maxWidthOption="alertDialog.maxWidthOption"
    :title="alertDialog.title"
    :message="alertDialog.message"
    :focus="alertDialog.focus"
    @confirm="closeAlertDialog"
  />
</template>

<script>
import AlertDialog from "@/components/AlertDialog.vue";
import { defineComponent, ref, computed, onMounted, watch } from "vue";
import { storeToRefs } from "pinia";
import { useI18n } from "vue-i18n";
import { useContentsStore } from "@/store/contents";
import { useCommonStore } from "@/store/common";
import { format } from "date-fns";
import menuData from "@/data/menuData.js";
import ubistApi from "@/lib/ubistApi";
import SimpleTabCondition from "@/components/pattern/SimpleTabCondition.vue";
import SimpleCondition from "@/components/pattern/SimpleCondition.vue";
import ComplexCondition from "@/components/pattern/ComplexCondition.vue";
import PatternReport from "@/components/pattern/PatternReport.vue";
import constants from "@/data/constants.js";
import AsideContentList from "@/components/pattern/AsideContentList.vue";

export default defineComponent({
  name: "Pattern_ATC",
  components: {
    PatternReport,
    AlertDialog,
    AsideContentList,
  },
  setup() {
    const menuName = "Pattern_ATC";

    //AlertDialog
    const isAlertDialogOpen = ref(false);
    const alertDialog = ref({
      maxWidthOption: "",
      title: "",
      message: "",
      focus: "",
    });
    const closeAlertDialog = () => {
      isAlertDialogOpen.value = false;
    };

    const { t } = useI18n();
    const contentsStore = useContentsStore();
    const {
      contents,
      patternSelected,
      patternContentIndex,
      patternSelectedItems,
      complexSelectedItems,
    } = storeToRefs(contentsStore);
    const periodData = ref(null); // 기간 데이터를 저장하기 위한 ref를 추가.
    const isAnalysisComplete = ref(false);
    const isComponent = ref(true);
    const isLoad = ref(false);
    const viewType = ref("");

    watch([patternContentIndex], (curr, prev) => {
      if (prev[0] !== curr[0]) {
        selectTab(patternContentIndex.value);
      }
    });

    const refreshTab = async () => {
      isLoad.value = false;
      await fnInit();
      selectTab(0);
    };

    const fnInit = async () => {
      patternContentIndex.value = 0;
      patternSelected.value = [];
      patternSelectedItems.value = [];
      complexSelectedItems.value = [];
      const menuCode = getMenuCode(menuData, menuName);
      const resPatternContents = await contentsStore.getPatternContents(menuCode);
      const resPatternContentsByCustomer = await contentsStore.getPatternContentsByCustomer(menuCode);
      await contentsStore.onInitPatten();
      //기본값 셋팅
      await contentsStore.onInitPattenDefaultSet(menuCode, resPatternContents, resPatternContentsByCustomer);
      // 즐겨찾기 관련 데이터 세팅
      await contentsStore.onInitFavorte();
      isLoad.value = true;
    };

    onMounted(async () => {
      refreshTab();
    });

    // Ensure contents.value is always defined
    contents.value = contents.value || [];

    const patternContents = [
      { index: 0, component: SimpleCondition },
      { index: 1, component: SimpleCondition },
      { index: 2, component: ComplexCondition },
      { index: 3, component: SimpleCondition },
    ];

    //분석하기 드롭다운
    const isDropped = ref(false);
    //분석하기 드롭다운
    const dropIt = () => {
      isDropped.value = !isDropped.value;
    };

    const focusout = () => {
      if (!isBtnDiv.value) {
        isDropped.value = false;
      }
    };

    const isBtnDiv = ref(false);
    const handleMouseOver = () => {
      isBtnDiv.value = true;
    };
    const handleMouseOut = () => {
      isBtnDiv.value = false;
    };

    //리포트 결과보기
    const onPatternReport = (searchtype) => {
      isAnalysisComplete.value = false;
      
      const validation = contentsStore.onClickPatternValidation(getMenuCode(menuData, menuName), commonStore.openAlertDialog, null);
      if (!validation) return;
      
      isComponent.value = false;
      // isAnalysisComplete.value = true;
      viewType.value = searchtype;

      patternContentIndex.value = null;

      setTimeout(() => {
        isAnalysisComplete.value = true;
      }, 1);
    };

    //리포트 엑셀 내보내기 결과보기
    const commonStore = useCommonStore();
    const { customer } = storeToRefs(commonStore);
    const onStartDossierExcel = async () => {
      const menuCode = getMenuCode(menuData, menuName);

      const validation = contentsStore.onClickPatternValidation(menuCode, commonStore.openAlertDialog, null);
      if (!validation) return;
      
      await contentsStore.onPatternExcel(menuCode, "excel", commonStore.openAlertDialog);
    };
    const onStartDossierEmail = async () => {
      const menuCode = getMenuCode(menuData, menuName);

      const validation = contentsStore.onClickPatternValidation(menuCode, commonStore.openAlertDialog, null);
      if (!validation) return;
      
      await contentsStore.onPatternEmail(menuCode, "excel", commonStore.openAlertDialog);
    };

    const selectTab = async (index) => {
      if (index === null || index === undefined || index >= contents.value.length || index < 0) {
        return;
      }
      patternContentIndex.value = index;
      contentsStore.onInitPatten();

      const content = contents.value[index];
      let code = null;
      let type = null;
      let group = null;
      if (typeof content.groupContents !== "undefined") {
        code = content.groupContents[0].code;
        type = content.groupContents[0].type;
        group = true;
      } else {
        code = content.code;
        type = content.type;
        group = false;
      }

      contentsStore.onClickPatternContent(code, type, group, index, true);

      isComponent.value = true;
      isAnalysisComplete.value = false;
    };

    const selectedComponent = computed(() => {
      return patternContents[patternContentIndex.value].component;
    });
    const selectedComponentIndex = computed(() => {
      return patternContentIndex.value;
    });

    const getMenuCode = (menuMap, name) => {
      let code = "";
      menuMap.forEach((menu) => {
        if (name === menu.name) {
          code = menu.code;
          return true;
        }
      });
      return code;
    };

    const goToNextTab = () => {
      selectTab(patternContentIndex.value + 1);
    };

    const goToBeforeTab = () => {
      selectTab(patternContentIndex.value - 1);
    };

    return {
      //AlertDialog
      isAlertDialogOpen,
      alertDialog,
      closeAlertDialog,

      contents,
      parentMenu: menuName,
      parentMenuCode: getMenuCode(menuData, menuName),
      patternContentIndex,
      patternContents,
      selectTab,
      selectedComponent,
      selectedComponentIndex,
      patternSelected,
      goToNextTab,
      goToBeforeTab,
      periodData,
      refreshTab,
      isAnalysisComplete,
      isComponent,
      customer,

      onPatternReport,
      onStartDossierExcel,
      onStartDossierEmail,
      viewType,
      isLoad,
      dropIt,
      isDropped,
      focusout,
      isBtnDiv,
      handleMouseOver,
      handleMouseOut,

      constants,
    };
  },
  async created() {},
});
</script>

<style scoped>
.sub-content {
  display: flex;
  width: 100%;
  height: 100%;
}

/* 20230704 수정 { */
.pattern-contents {
  display: flex;
  flex-direction: column;
  width: 252px;
  position: relative;
  padding-right: 20px;
}

.pattern-contents::before {
  position: absolute;
  right: 0;
  top: -20px;
  content: "";
  width: 1px;
  height: calc(100% + 40px);
  background-color: #ddd;
}
/* } 20230704 수정 */

.each-pattern-tap-wrap {
  counter-reset: list-number;
}
.each-pattern-taps {
  position: relative;
  width: 100%;
  flex-direction: column;
  padding: 18px 16px;
  cursor: pointer;
  border: var(--border-line);
  border-radius: var(--border-radius);
  counter-increment: list-number;
  background-color: #f4f4f4;
  transition: all 0.3s;
}

.each-pattern-taps::before {
  position: absolute;
  top: 18px;
  left: 16px;
  content: counter(list-number);
  width: 22px;
  height: 22px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 14px;
  color: #fff;
  background-color: #d3d3d3;
  border-radius: 50%;
}

.each-pattern-taps ~ .each-pattern-taps {
  margin-top: 5px;
}

.each-pattern-taps.active {
  background-color: #fff;
  border-color: var(--primary-color);
}

.each-pattern-taps.active::before {
  background-color: var(--primary-color);
  color: #fff;
}

.each-pattern-taps.active .option-name {
}

.tap-title {
  padding-left: 30px;
  font-size: 16px;
  font-weight: 700;
  line-height: 22px;
}

.option-name {
  position: relative;
  margin-top: 12px;
  font-size: 13px;
  font-weight: 400;
  line-height: 1.4;
  color: var(--font-sec-color);
  padding-left: 30px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.option-name::before {
  position: absolute;
  left: 9px;
  top: 7px;
  content: "";
  width: 5px;
  height: 5px;
  background-color: #d6d6d6;
  border-radius: 50%;
}

/* .pattern-contents {
  float: left;
} */

/* .content {
  float: right;
  height: 150%;
} */

/* 20230704 수정 { */
.content {
  position: relative;
  display: flex;
  flex-direction: column;
  flex: 1 1 0;
  /* padding: 10px; */
  margin-left: 20px;
  /* border: var(--border-line);
  border-radius: var(--border-radius); */
  transition: all 0.3s;
}

.next-step-wrap {
  display: flex;
  justify-content: flex-start;
  gap: 0 6px;
}

.next-step-wrap button {
  border: var(--border-line);
  /* border-color: #141414; */
  /* font-size: 15px; */
  font-weight: 600;
  /* padding: 8px 20px; */
  transition: all 0.3s;
}
.next-step-wrap button:hover {
  /* border-color: var(--primary-color); */
  /* color: var(--primary-color); */
}

.next-step-wrap .next-button::after {
  content: var(--button-text);
}

.next-step-wrap .prev-button::after {
  content: var(--button-text);
}
/* } 20230704 수정 */

.pattern-content-buttons {
  display: flex;
  justify-content: space-between;
  margin-top: 40px; /* 20230704 수정 */
  height: 48px;
}

.pattern-content-buttons .btn {
  height: 100%;
  padding: 0 12px;
}

.pattern-content-buttons .btn-dropdown-group {
  margin-left: 6px;
  border: 1px solid var(--primary-color);
  background-color: var(--primary-color);
}

.pattern-content-buttons .btn-dropdown-group button {
  color: #fff;
}

.pattern-content-buttons .btn-dropdown {
  border-color: #1042be;
}

/*
.refresh-button,
.analyze-button {
  padding: 10px;
  font-size: 14px;
  border: 1px solid #ccc;
  cursor: pointer;
}

.refresh-button {
  margin-right: 10px;
}
*/
</style>
